/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'edit-trans': {
    width: 8,
    height: 9,
    viewBox: '0 0 8 9',
    data: '<path pid="0" d="M.043 8.67l.276-2.587L4.21 2.19l.494.493L.997 6.393l-.16 1.464 1.466-.159L6.01 3.99l.494.494-3.893 3.892-2.57.293zm2.076-1.574l3.498-3.5-.502-.501-3.49 3.49.502.502-.008.009zm4.737-2.93l-2.31-2.31.829-.829a.98.98 0 0 1 1.39 0l.912.912a.98.98 0 0 1 0 1.39l-.83.829.01.008zm.327-1.33a.288.288 0 0 0 0-.403l-.904-.904a.288.288 0 0 0-.402 0l-.335.335L6.848 3.17l.335-.335z" _fill="#376F99" fill-rule="nonzero"/>'
  }
})
